import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RCountBubble } from './RCountBubble';

export interface RTab {
    key: string;
    label: string;
    icon?: React.ComponentType<{ sx?: object }>;
    badge?: number;
}

interface RTabsProps {
    tabs: RTab[];
    activeTab: string;
    onTabChange: (key: string) => void;
    fullWidth?: boolean;
}

export function RTabs({ tabs, activeTab, onTabChange, fullWidth }: RTabsProps) {
    return (
        <TabsContainer $fullWidth={!!fullWidth}>
            {tabs.map((tab) => {
                const active = tab.key === activeTab;
                return (
                    <TabButton
                        key={tab.key}
                        active={active}
                        $fullWidth={!!fullWidth}
                        onClick={() => onTabChange(tab.key)}
                    >
                        {tab.icon && <tab.icon sx={{ fontSize: 18 }} />}
                        {tab.label}
                        {tab.badge != null && tab.badge > 0 && <RCountBubble count={tab.badge} />}
                    </TabButton>
                );
            })}
        </TabsContainer>
    );
}

const TabsContainer = styled('div', { shouldForwardProp: (p) => p !== '$fullWidth' })<{ $fullWidth: boolean }>(
    ({ $fullWidth }) => ({
        display: $fullWidth ? 'flex' : 'inline-flex',
        width: $fullWidth ? '100%' : undefined,
        gap: 4,
        padding: 4,
        borderRadius: 10,
        backgroundColor: Colors.lightGrey,
    }),
);

const TabButton = styled('button', { shouldForwardProp: (p) => p !== '$fullWidth' })<{
    active: boolean;
    $fullWidth: boolean;
}>(({ active, $fullWidth }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    flex: $fullWidth ? 1 : undefined,
    padding: '8px 20px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    borderRadius: 8,
    border: active ? `1px solid ${Colors.lightGrey}` : '1px solid transparent',
    backgroundColor: active ? Colors.white : 'transparent',
    color: active ? Colors.darkNavy : Colors.mediumGrey,
    boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
    outline: 'none',
    transition: 'all 0.15s',
    '&:hover': {
        color: Colors.darkNavy,
    },
    '&:focus, &:focus-visible': {
        outline: 'none',
    },
}));
